import React from "react"

import { Room } from "shared/types/Room"

import { NewRoomOverlay } from "./NewRoomOverlay"
import { useNewRoomOverlayModel } from "./model/useNewRoomOverlayModel"

export interface NewRoomOptions {
  room?: Partial<Room>
  hideProject?: boolean
}

export interface NewRoomOverlayPayload extends NewRoomOptions {
  projectID: string
}

export interface NewProjectOverlayConnectorProps {
  payload: NewRoomOverlayPayload
}

export const NewRoomOverlayConnector = React.memo(
  (props: NewProjectOverlayConnectorProps) => (
    <NewRoomOverlay autoFocus {...useNewRoomOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    NEW_ROOM_OVERLAY: NewRoomOverlayPayload
  }
}
